import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/home")({
  beforeLoad: () => {
    throw redirect({ to: "/" })
  },
})
